import { useSaldoResumo } from './useSaldoResumo';
import { useLimiteKmAviso } from './abas/creditos/useCreditos';

type Estado = 'normal' | 'baixo' | 'zerado';

function estadoDoSaldo(saldoDisponivel: number, kmDisponivel: number | null, limiteKm: number): Estado {
  if (saldoDisponivel <= 0) return 'zerado';
  if (kmDisponivel !== null && kmDisponivel < limiteKm) return 'baixo';
  return 'normal';
}

const AVISO: Record<Estado, string | null> = {
  normal: null,
  baixo: 'Seu crédito está acabando. Você continua emitindo normalmente até ele terminar.',
  zerado: 'Sem crédito não é possível emitir novas ATF. A recarga por Pix cai assim que o banco confirma.',
};

interface Props {
  onComprarCredito: () => void;
}

/**
 * Card de saldo (handoff §5) — usado em Início e Créditos. O herói é a
 * linha de EMISSÕES ("Pelo menos N emissões"); o km é secundário, nunca o
 * número principal.
 */
export function SaldoCardHero({ onComprarCredito }: Props) {
  const { saldo } = useSaldoResumo();
  const limiteKm = useLimiteKmAviso();

  if (!saldo) return null; // ainda carregando (undefined) ou pós-pago (null) — handoff §Decisões abertas #4

  const estado = estadoDoSaldo(saldo.saldoDisponivel, saldo.kmDisponivel, limiteKm);
  const aviso = AVISO[estado];
  const emissoes = saldo.emissoesMinimas;
  const moeda = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <section className={`co-saldo-cartao co-saldo-cartao-${estado}`} aria-label="Saldo de crédito">
      <span className="co-saldo-cartao-rotulo">Saldo disponível</span>
      <div className="co-saldo-cartao-valor">{moeda(saldo.saldoDisponivel)}</div>
      <div className="co-saldo-cartao-linha">
        {emissoes && emissoes > 0 ? `Pelo menos ${emissoes} emissõe${emissoes === 1 ? '' : 's'}` : 'Nenhuma emissão disponível'}
      </div>
      {saldo.kmDisponivel !== null && (
        <p className="co-saldo-cartao-apoio">
          ~{saldo.kmDisponivel} km de emissão
          {saldo.valorPorKmVigente != null && ` · ${moeda(saldo.valorPorKmVigente)}/km`}
        </p>
      )}

      {aviso && <p className="co-saldo-cartao-apoio">{aviso}</p>}

      <div className="co-acoes">
        <button
          type="button"
          // Secundário: na tela, o principal é outra coisa (continuar a emissão,
          // escolher o pacote). Sobre o fundo escuro, o claro.
          className={`co-btn ${estado === 'normal' ? 'co-btn-claro' : 'co-btn-secundario'}`}
          onClick={onComprarCredito}
        >
          Comprar crédito
        </button>
      </div>
    </section>
  );
}
